import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection
} from 'angularfire2/firestore';
import { Observable } from 'rxjs';
import * as firebase from 'firebase/app';
import * as moment from 'moment';

import { IJob, IJobStaff } from './../../interfaces/jobs';
@Injectable()
export class JobsProvider {
  private jobsCollection: AngularFirestoreCollection<IJob>;
  private staffJobsCollection: AngularFirestoreCollection<IJobStaff>;

  constructor(private db: AngularFirestore) {}

  createJob(job: IJob) {
    const id = this.db.createId();
    job.id = id;
    job.status = 0;
    job.paymentStatus = 0;
    const jobRef = this.db.doc(`jobs/${job.id}`);
    jobRef.set(job);
    return jobRef.update({
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    });
  }

  startJob(jobId: string) {
    const jobRef = this.db.doc(`jobs/${jobId}`);
    return jobRef.update({
      status: 2,
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    });
  }

  completeJob(jobId: string) {
    const jobRef = this.db.doc(`jobs/${jobId}`);
    return jobRef.update({
      status: 3,
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    });
  }

  createJobStaff(jobStaff: IJobStaff) {
    const id = this.db.createId();
    jobStaff.id = id;
    jobStaff.status = 0;
    const jobStaffRef = this.db
      .collection(`jobStaff`)
      .doc(`${jobStaff.jobId}`)
      .collection('staff')
      .doc(`${jobStaff.userId}`);
    const userJobsRef = this.db
      .collection(`userJobs`)
      .doc(`${jobStaff.userId}`)
      .collection('jobs')
      .doc(`${jobStaff.jobId}`);
    jobStaffRef.set(jobStaff);
    userJobsRef.set(jobStaff);
    userJobsRef.update({
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    });
    return jobStaffRef.update({
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    });
  }

  getOpenJobs(): Observable<IJob[]> {
    let now = moment().format();
    console.log(now);
    this.jobsCollection = this.db.collection<IJob>('jobs', ref =>
      ref.where('status', '==', 0).where('paymentStatus', '==', 1).orderBy('start')
    );
    return this.jobsCollection.valueChanges();
  }

  getRecruiterJobs(uid: string): Observable<IJob[]> {
    this.jobsCollection = this.db.collection<IJob>('jobs', ref =>
      ref.where('createdBy', '==', uid).orderBy('start')
    );
    return this.jobsCollection.valueChanges();
  }

  getUserJobs(userId: string): Observable<IJobStaff[]> {
    this.staffJobsCollection = this.db
      .collection('userJobs')
      .doc(`${userId}`)
      .collection<IJobStaff>('jobs');
    return this.staffJobsCollection.valueChanges();
  }

  getJobStaff(jobId: string): Observable<IJobStaff[]> {
    this.staffJobsCollection = this.db
      .collection('jobStaff')
      .doc(`${jobId}`)
      .collection<IJobStaff>('staff');
    return this.staffJobsCollection.valueChanges();
  }

  getJobDetails(id: string): Observable<IJob> {
    return this.db
      .collection('jobs')
      .doc<IJob>(id)
      .valueChanges();
  }

  deleteJobApplication(jobId: string, userId: string) {
    const jobStaffRef = this.db
      .collection(`jobStaff`)
      .doc(`${jobId}`)
      .collection('staff')
      .doc(`${userId}`);
    const userJobsRef = this.db
      .collection(`userJobs`)
      .doc(`${userId}`)
      .collection('jobs')
      .doc(`${jobId}`);
    jobStaffRef.delete();
    return userJobsRef.delete();
  }

  updateJobApplication(jobId: string, userId: string, status: number) {
    const newStatus = { status: status };
    const jobStaffRef = this.db
      .collection(`jobStaff`)
      .doc(`${jobId}`)
      .collection('staff')
      .doc(`${userId}`);
    const userJobsRef = this.db
      .collection(`userJobs`)
      .doc(`${userId}`)
      .collection('jobs')
      .doc(`${jobId}`);
    jobStaffRef.update(newStatus);
    userJobsRef.update(newStatus);
    jobStaffRef.update({
      modifiedAt: firebase.firestore.FieldValue.serverTimestamp()
    });
    return userJobsRef.update({
      modifiedAt: firebase.firestore.FieldValue.serverTimestamp()
    });
  }



}



// WEBPACK FOOTER //
// ./src/providers/jobs/jobs.ts